module.exports = __webpack_public_path__ + "img/MURALE_EDGE.9f769661.jpg";